import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getAccountId } from '../utils/storage';

export function useOnboardingBeforeUnload(enabled = true) {
    const {pathname} = useLocation();

    const disabled = !enabled || ["/conditions"].includes(pathname);

    useEffect(() => {
        if (disabled || !getAccountId()) {
            return undefined;
        }

        const onBeforeUnload = (event: BeforeUnloadEvent) => {
            event.preventDefault();
            event.returnValue = '';
        };

        window.addEventListener('beforeunload', onBeforeUnload);
        return () => window.removeEventListener('beforeunload', onBeforeUnload);
    }, [enabled]);
}
